export default "__VITE_ASSET__PGUjFqKp__"